{
  "title": "Summon Warrior Spirit (UA)",
  "source": "Unearthed Arcana 85 - Wonders of the Multiverse",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a gilded playing card depicting a knight worth at least 300 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a warrior spirit from the legendary Deck of Many Things. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Warrior Spirit stat block. When you cast the spell, choose a type of warrior: barbarian, fighter, or monk. The warrior resembles a humanoid armed appropriately to the chosen class, which determines certain traits in its stat block. The warrior disappears when it drops to 0 hit points or when the spell ends.",
    "The warrior is an ally to you and your companions. In combat, the warrior shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the creature assumes the higher level for that casting wherever it uses the spell’s level in its stat block.",
    "Warrior Spirit",
    "Medium Undead",
    "Armor Class: 13 + the level of the spell + 2 (Fighter only)",
    "Hit Points: 30 (Babarian and Fighter only) or 20 (Monk only) + 10 for each spell level above 3rd",
    "Speed: 30 ft., 40 ft. (Monk only)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "16 (+3)",
    "16 (+3)",
    "14 (+2)",
    "10 (+0)",
    "16 (+3)",
    "9 (-1)",
    "Saving Throws: Str +3, Dex +3",
    "Damage Resistances: poison",
    "Condition Immunities: charmed, poisoned",
    "Senses: passive Perception 13",
    "Languages: Common, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Actions",
    "Multiattack. The warrior makes a number of attacks equal to half this spell’s level (rounded down).",
    "Reckless Strike (Barbarian Only). Melee Weapon Attack: your spell attack modifier to hit (with advantage), reach 5 ft., one target. Hit: 1d12 + 3 + the spell’s level slashing damage, and attacks made against the warrior until the start of its next turn are made with advantage.",
    "Rallying Strike (Fighter Only). Melee or Ranged Weapon Attack: your spell attack modifier to hit, reach 5 ft., or range 20/60 ft., one target. Hit: 1d6 + 3 + the spell’s level piercing damage, and the warrior can choose another creature it can see within 20 feet of itself. The chosen creature gains 1d6 temporary hit points.",
    "Unarmed Strike (Monk Only). Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d4 + 3 + the spell’s level bludgeoning damage, and the target must succeed on a Strength saving throw against your spell save DC or be knocked prone.",
    "Bonus Actions",
    "Flurry of Blows (Monk Only). The monk makes one Unarmed Strike attack."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
